import { DefaultFooter } from '@ant-design/pro-components';

export default () => <DefaultFooter copyright="shoppykey" links={[]} />;
